import moment from "moment";
import { RefreshCw } from "lucide-react";

import { Badge } from "@/components/ui/badge";

export function LastUpdate({ lastUpdate }) {
  if (!lastUpdate) return null;

  return (
    <Badge variant="outline" size="lg">
      <RefreshCw />
      {`Updated ${moment(lastUpdate).fromNow()}`}
    </Badge>
  );
}
